import { render, staticRenderFns } from "./SyncAuditLogs.vue?vue&type=template&id=2dd7ec70&scoped=true"
import script from "./SyncAuditLogs.vue?vue&type=script&lang=ts"
export * from "./SyncAuditLogs.vue?vue&type=script&lang=ts"
import style0 from "./SyncAuditLogs.vue?vue&type=style&index=0&id=2dd7ec70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd7ec70",
  null
  
)

export default component.exports